import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { addDays, getUnixTime, parse, startOfDay, subDays } from 'date-fns';

export const dateSameOrHigher =
    (dateField1: string, dateField2: string, validatorField: { [key: string]: boolean }): ValidatorFn =>
    (control: AbstractControl): { [key: string]: boolean } | null => {
        const dateStr1 = control.parent?.get(dateField1)?.value;
        const dateStr2 = control.parent?.get(dateField2)?.value;

        if (!dateStr1 || !dateStr2) {
            return null;
        }

        // TODO: update format string in dependecy to country and selected language
        const date1 = getUnixTime(parse(dateStr1, 'dd.MM.yyyy', new Date()));
        const date2 = getUnixTime(parse(dateStr2, 'dd.MM.yyyy', new Date()));

        if (date1 !== undefined && date2 !== undefined && date1 < date2) {
            return validatorField;
        }

        return null;
    };

export const dateLower =
    (dateField1: string, dateField2: string, validatorField: { [key: string]: boolean }): ValidatorFn =>
    (control: AbstractControl): { [key: string]: boolean } | null => {
        const dateStr1 = control.parent?.get(dateField1)?.value;
        const dateStr2 = control.parent?.get(dateField2)?.value;

        if (!dateStr1 || !dateStr2) {
            return null;
        }

        // TODO: update format string in dependecy to country and selected language
        const date1 = getUnixTime(parse(dateStr1, 'dd.MM.yyyy', new Date()));
        const date2 = getUnixTime(parse(dateStr2, 'dd.MM.yyyy', new Date()));

        if (date1 !== undefined && date2 !== undefined && date1 > date2) {
            return validatorField;
        }

        return null;
    };

export const dateUpToPastDays =
    (maxDaysInPast: number): ValidatorFn =>
    (control: AbstractControl): ValidationErrors | null => {
        const dateStr = control.value;

        if (!dateStr) {
            return null;
        }

        const today = new Date();
        // TODO: update format string in dependecy to country and selected language
        const selectedDate = getUnixTime(startOfDay(parse(dateStr, 'dd.MM.yyyy', new Date())));
        const minDate = getUnixTime(subDays(startOfDay(today), maxDaysInPast));

        if (selectedDate < minDate) {
            return { dateInPast: true };
        }

        return null;
    };

export const dateUpToFutureDays =
    (maxDaysInFuture: number): ValidatorFn =>
    (control: AbstractControl): ValidationErrors | null => {
        const dateStr = control.value;

        if (!dateStr) {
            return null;
        }

        const today = new Date();
        // TODO: update format string in dependecy to country and selected language
        const selectedDate = getUnixTime(startOfDay(parse(dateStr, 'dd.MM.yyyy', new Date())));
        const maxDate = getUnixTime(addDays(startOfDay(today), maxDaysInFuture));

        if (selectedDate > maxDate) {
            return { dateInFuture: true };
        }

        return null;
    };
